// project-imports
import { getRequest, postRequest, putRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - DC REQUEST ||============================== //

export async function handleDCRequests(action: APIAction) {
  switch (action.method) {
    case 'create':
      return postRequest('/dc-requests', action.data);
    // case 'read': {
    //   // Construir query params dinámicamente según action.id y action.data
    //   const params = new URLSearchParams();

    //   if (action.data) {
    //     Object.entries(action.data).forEach(([key, value]) => {
    //       if (value !== undefined && value !== null) {
    //         // Normalizamos claves conocidas (solo las que aplican aquí)
    //         if (key === 'devComId') params.append('dc-id', String(value));
    //         else if (key === 'type' || key === 'reqType') params.append('type', String(value));
    //         // cualquier otra clave se ignora para mantenerlo controlado
    //       }
    //     });
    //   }

    //   // Si hay un ID general y no hay dc-id, lo usamos como fallback
    //   if (action.id && !params.has('dc-id')) {
    //     params.append('dc-id', String(action.id));
    //   }

    //   const queryString = params.toString() ? `?${params.toString()}` : '';
    //   return getRequest(`/dc-requests${queryString}`);
    // }
    case 'read': {
      const params = new URLSearchParams();

      if (action.data) {
        Object.entries(action.data).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            if (key === 'devComId') params.append('dc-id', String(value));
            else if (key === 'type' || key === 'reqType') params.append('type', String(value));
          }
        });
      }

      // ⚙️ Solo usamos action.id como fallback si no se trata de "closed_development"
      const isClosedDevelopment = action.data?.type === 'closed_development';
      if (action.id && !params.has('dc-id') && !isClosedDevelopment) {
        params.append('dc-id', String(action.id));
      }

      const queryString = params.toString() ? `?${params.toString()}` : '';
      return getRequest(`/dc-requests${queryString}`);
    }
    case 'update':
      return putRequest(`/dc-requests/${action.id}`, action.data);
    default:
      console.info('[ApiManager > handleApiAction > handleDCRequests] - Unknown method');
      break;
  }
}
